import { iconArrowRightWhite } from "assets/icons";
import { Button } from "components/Button";
import React from "react";
import {TableCards} from "./styles"

interface PropertyProps {
  name?: string,
  value?: string,
  action?: () => void,
}

interface TableModifiedCardsProps {
  properties?: PropertyProps[],
}

export const TableModifiedCards:React.FC<TableModifiedCardsProps> = ({properties}) => {
  return (
    <TableCards>
      {properties?.map(property => (
        <div
          className="card"
          key={property.name}
        >
          <span>{property.name}</span>
          <div className="data-container">
            <h2>{property.value}</h2>
            {!!property.action && 
              <Button    
                className="button-link"          
                typeBtn="blue"
                size="small"
                onlyIcon={true}
                icon={iconArrowRightWhite}
                onClick={property.action}
              />
             }
          </div>
        </div>
      ))}
    </TableCards>
  )
}